import { FilterMode, MetadataCloud } from "@doitintl/cmp-models";

import AmazonWebServicesIcon from "../../../assets/aws-logo.svg";
import AmazonWebServicesIconDarkMode from "../../../assets/aws-logo-dark-mode.svg";
import MicrosoftAzureIcon from "../../../assets/azure-logo.svg";
import CloudZeroIcon from "../../../assets/cloudzero-logo.svg";
import CloudZeroIconDarkMode from "../../../assets/cloudzero-logo-white.svg";
import DatadogIcon from "../../../assets/datadog-logo.png";
import DatadogIconDarkMode from "../../../assets/datadog-logo-white.png";
import DoitLogo from "../../../assets/doit-logo-hero-square.svg";
import GoogleCloudIcon from "../../../assets/google-cloud.png";
import OpenaiIcon from "../../../assets/openai-logo.svg";
import OpenaiIconDarkMode from "../../../assets/openai-logo-white.svg";
import SnowflakeIcon from "../../../assets/snowflake.svg";
import { type MetadataOption } from "../../../types";
import { FilterModeOption } from "./types";

export const getPlural = (selected: MetadataOption) => {
  const label = selected.data.label ?? selected.data.field;
  const plural = selected.data.plural ?? label;
  return { plural, label };
};

export const getMode = (rule: FilterModeOption): FilterMode => {
  switch (rule) {
    case FilterModeOption.IS:
    case FilterModeOption.IS_NOT:
      return FilterMode.IS;
    case FilterModeOption.MATCHES_REGEX:
    case FilterModeOption.DOES_NOT_MATCHES_REGEX:
      return FilterMode.REGEXP;
    case FilterModeOption.CONTAINS:
    case FilterModeOption.DOES_NOT_CONTAIN:
      return FilterMode.CONTAINS;
    case FilterModeOption.STARTS_WITH:
      return FilterMode.STARTS_WITH;
    case FilterModeOption.ENDS_WITH:
      return FilterMode.ENDS_WITH;
    default:
      return FilterMode.IS;
  }
};

export const getModeLabel = (rule, reverse: boolean): FilterModeOption => {
  switch (rule) {
    case "is":
      return reverse ? FilterModeOption.IS_NOT : FilterModeOption.IS;
    case "regexp":
      return reverse ? FilterModeOption.DOES_NOT_MATCHES_REGEX : FilterModeOption.MATCHES_REGEX;
    case "contains":
      return reverse ? FilterModeOption.DOES_NOT_CONTAIN : FilterModeOption.CONTAINS;
    case "starts_with":
      return FilterModeOption.STARTS_WITH;
    case "ends_with":
      return FilterModeOption.ENDS_WITH;
    default:
      return reverse ? FilterModeOption.IS_NOT : FilterModeOption.IS;
  }
};

export const getFilterModeValues = (mode: FilterModeOption) => ({
  inverse:
    mode === FilterModeOption.IS_NOT ||
    mode === FilterModeOption.DOES_NOT_CONTAIN ||
    mode === FilterModeOption.DOES_NOT_MATCHES_REGEX,
  mode: getMode(mode),
});

export const getInverse = (mode: FilterModeOption) =>
  mode === FilterModeOption.IS_NOT ||
  mode === FilterModeOption.DOES_NOT_CONTAIN ||
  mode === FilterModeOption.DOES_NOT_MATCHES_REGEX;

export const getProviderIconFromOptionValue = (option: string, isDarkMode: boolean): string | null => {
  const optionLower = option.toLowerCase();

  if (optionLower.includes(MetadataCloud.AMAZON_WEB_SERVICES)) {
    return isDarkMode ? AmazonWebServicesIconDarkMode : AmazonWebServicesIcon;
  }
  if (optionLower.includes(MetadataCloud.GOOGLE_CLOUD)) {
    return GoogleCloudIcon;
  }
  if (optionLower.includes(MetadataCloud.MICROSOFT_AZURE)) {
    return MicrosoftAzureIcon;
  }
  if (optionLower.includes(MetadataCloud.DATAHUB)) {
    return DoitLogo;
  }
  if (optionLower.includes(MetadataCloud.SNOWFLAKE)) {
    return SnowflakeIcon;
  }
  if (optionLower.includes(MetadataCloud.DATADOG)) {
    return isDarkMode ? DatadogIconDarkMode : DatadogIcon;
  }
  if (optionLower.includes(MetadataCloud.OPENAI)) {
    return isDarkMode ? OpenaiIconDarkMode : OpenaiIcon;
  }
  if (optionLower.includes(MetadataCloud.CLOUDZERO)) {
    return isDarkMode ? CloudZeroIconDarkMode : CloudZeroIcon;
  }

  return null;
};

export const publisherRelevantIntegrations = (isDarkMode: boolean) =>
  new Map([
    [
      MetadataCloud.CLOUDZERO.toLowerCase(),
      {
        show: true,
        src: isDarkMode ? CloudZeroIconDarkMode : CloudZeroIcon,
      },
    ],
  ]);
